import script from "./ConfirmPasswordModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmPasswordModal.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmPasswordModal.vue?vue&type=style&index=0&id=22430de8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22430de8"]])

export default __exports__